import { useTranslation } from 'react-i18next';
import { Form, SocialIcon } from '@anytag/shared-atoms';
import { CountryOption, SelectOption } from '@anytag/shared-types';
import { SelectorField, SingleDatePickerField } from '@anytag/shared-molecules';
import { TrendingPostsFilterFormKeys, TrendingPostsTabType } from './schemaTypes';

export interface TemplateProps {
  onSubmit?: () => void;
  allCountryOptions: CountryOption[];
  allCategoryOptions: SelectOption<string>[];
}

export const Template = ({ allCountryOptions, allCategoryOptions, onSubmit }: TemplateProps) => {
  const { t } = useTranslation();

  const socialMediaOptions: SelectOption<TrendingPostsTabType>[] = [
    {
      label: t<string>('Instagram'),
      value: TrendingPostsTabType.INSTAGRAM,
      prefixIcon: <SocialIcon type="INSTAGRAM" />
    },
    { label: t<string>('Youtube'), value: TrendingPostsTabType.YOUTUBE, prefixIcon: <SocialIcon type="YOUTUBE" /> },
    { label: t<string>('X(Twitter)'), value: TrendingPostsTabType.TWITTER, prefixIcon: <SocialIcon type="TWITTER" /> },
    { label: t<string>('Facebook'), value: TrendingPostsTabType.FACEBOOK, prefixIcon: <SocialIcon type="FACEBOOK" /> },
    {
      label: t<string>('Facebook Fanpage'),
      value: TrendingPostsTabType.FACEBOOK_PAGE,
      prefixIcon: <SocialIcon type="FACEBOOK_PAGE" />
    },
    { label: t<string>('TikTok'), value: TrendingPostsTabType.TIKTOK, prefixIcon: <SocialIcon type="TIKTOK" /> }
  ];

  return (
    <Form.Fields>
      <SelectorField<TrendingPostsFilterFormKeys>
        name="tab"
        clearable={false}
        onSubmit={onSubmit}
        options={socialMediaOptions}
        title={t('Selector.Social Media')}
        placeholder={t<string>('Selector.Social Media')}
        showAllOptions
        disabled // TODO-Trend: Currently we only show default social media YT and disable the selector
      />

      <SelectorField<TrendingPostsFilterFormKeys>
        name="countryId"
        clearable={false}
        onSubmit={onSubmit}
        options={allCountryOptions}
        title={t('Selector.Country')}
        placeholder={t<string>('Selector.Country')}
      />

      <SelectorField<TrendingPostsFilterFormKeys>
        name="categoryId"
        clearable={false}
        onSubmit={onSubmit}
        title={t('Selector.Topic')}
        options={allCategoryOptions}
      />

      <SingleDatePickerField<TrendingPostsFilterFormKeys>
        name="date"
        title={t('Date')}
        onSubmit={onSubmit}
        disabledDays={{ after: new Date() }}
      />
      {/* Empty field to make the those fields align */}
      <Form.Field />
      <Form.Field />
    </Form.Fields>
  );
};
